module.exports = __webpack_public_path__ + "img/garageMovil.feef0a6f.png";